exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* #display {\n  color: white;\n} */\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/learn-js/Mehtris/src/app/score/score.component.css
// module id = ../../../../../src/app/score/score.component.css
// module chunks = main